import { Graph, Cell, NodeCell } from "@edp-pmf/grapheditor";
import { FlowNodeState, BpmnModel } from "@edp-pmf/bpmn-model";
import { StartMode } from "@gsp-wf/wf-process-model";
import { WfEditorUi } from "./WfEditorUi";
import { MxGraphNS, mxConstants, mxUtils } from "@edp-pmf/mxgraph-ts";
import { WfProcessCell } from "./wf-cell/WfProcessCell";
import { WfLocalePipe } from "../i18n/pipe/wf-process-editor-locale.pipe";

/**
 * 工作流画布类
 */
export class WfGraph extends Graph {
    localePipe: WfLocalePipe = null;
    editorUi: WfEditorUi;
    /**
     * 流程元素实例
     */
    processCell: WfProcessCell = new WfProcessCell();
    constructor(editorUi: WfEditorUi, container?: HTMLDivElement, model?: MxGraphNS.mxGraphModel, renderHint?: MxGraphNS.renderingHint, stylesheet?: MxGraphNS.mxStylesheet, themes?: Element) {
        super(editorUi, container, model, renderHint, stylesheet, themes);
    }

    bpmnCellsSelectionChanged(cells: Cell[], sender: MxGraphNS.mxEventSource, eventObject: MxGraphNS.mxEventObject): void {
      super.bpmnCellsSelectionChanged(cells, sender, eventObject);
      // 修改选中节点样式
      const selected = this.getSelectionCells() as NodeCell[];
      const all = this.getChildVertices(this.getDefaultParent()) as NodeCell[];
      all.forEach(c => {
          if (selected.includes(c) && c.imgUrls && c.imgUrls[FlowNodeState.Selected]) {
              c.setStyle(mxUtils.setStyle(c.getStyle(), mxConstants.STYLE_IMAGE, c.imgUrls[FlowNodeState.Selected]));
          } else {
              c.setStyle(mxUtils.setStyle(c.getStyle(), mxConstants.STYLE_IMAGE, c.imgUrls[FlowNodeState.Default]));
          }
          this.refresh(c);
      });
  }

    /**
     * 重写创建流程元素实例方法
     * @param bpmnModel
     * @returns
     */
    createProcessCell(bpmnModel: BpmnModel) {
        const processCell = new WfProcessCell();
        processCell.process = bpmnModel.DefaultProcess;
        processCell.plane = bpmnModel.DefaultDiagram.BpmnPlane;
        processCell.editorUi = this.editorUi;
        processCell.uiState = this.editorUi.uistate;
        return processCell;
    }

    /**
     * 给定新流程信息创建BpmnModel
     * @param newProcInfo
     * @param bizCmps
     */
    createBpmnModelWithProcInfo(newProcInfo: any, bizCmps: any) {
        const bpmnModel = this.createBpmnModel();
        this.bpmnModel = bpmnModel;
        this.processCell = this.createProcessCell(this.bpmnModel);
        if (this.editorUi.langCode === 'zh-CHS') {
          this.bpmnModel.DefaultProcess.Name = newProcInfo.name || bpmnModel.DefaultProcess.Name;
        }
        if(newProcInfo.nameLanguage) {
          this.bpmnModel.DefaultProcess.NameLanguage = newProcInfo.nameLanguage;
        }else {
          this.bpmnModel.DefaultProcess.NameLanguage = {
            [this.editorUi.langCode]: newProcInfo.name || bpmnModel.DefaultProcess.Name,
          }
        }
        //设置流程Header(业务对象ID、流程分类ID)
        this.processCell.setProcessHeader(newProcInfo.ffId, newProcInfo.bizObjId, newProcInfo.ffName, newProcInfo.startMode as StartMode);

        // 基于流程分类绑定参数，流程构件，流程表单
        this.processCell.updateFlowFormInfo(newProcInfo.formalParameters, newProcInfo.processBizComponnets, newProcInfo.executeForms, newProcInfo.customizeActions, bizCmps);
        this.processCell.modifyProcessTitleExpression(newProcInfo.processDescription);
    }
    setDefaultStyles(): void {
      super.setDefaultStyles();

      const styleSheet = this.getStylesheet();
      // 连线样式默认为正交
      const edgeStyle = styleSheet.getDefaultEdgeStyle();
      edgeStyle[mxConstants.STYLE_ROUNDED] = 1;
  }
}
